// extracted by mini-css-extract-plugin
module.exports = {"card":"TestimonialCard_card__9IHgw","header":"TestimonialCard_header__f_G3K","date":"TestimonialCard_date__ztbzf"};